import { inject, Injectable, InjectionToken, Type, ValueProvider } from '@angular/core';
import { EntityType } from '@panaya/ai-chat/shared';

interface CanvasEntityRendererRegistration {
    entityType: EntityType;
    component: Type<unknown>;
}

const CANVAS_ENTITY_RENDERERS = new InjectionToken<CanvasEntityRendererRegistration[]>('__CANVAS_ENTITY_RENDERERS__', {
    factory: (): CanvasEntityRendererRegistration[] => []
});

/**
 * Replaces the generic renderer for one entity type, for data a mapping cannot express. The
 * component is standalone and takes one signal input, `entity: DraftEntity`. A later registration for a type wins.
 */
export function provideCanvasEntityRenderer(entityType: EntityType, component: Type<unknown>): ValueProvider {
    return { provide: CANVAS_ENTITY_RENDERERS, useValue: { entityType, component }, multi: true };
}

@Injectable({ providedIn: 'root' })
export class CanvasEntityRendererRegistry {
    private readonly renderers = new Map<EntityType, Type<unknown>>(
        inject(CANVAS_ENTITY_RENDERERS).map(({ entityType, component }) => [entityType, component])
    );

    /** The host's renderer for the type, or `null` for the generic renderer. */
    public resolve(entityType: EntityType): Type<unknown> | null {
        return this.renderers.get(entityType) ?? null;
    }
}
